(() => {
  window.__HF_WAVE_TEXT__ = window.__HF_WAVE_TEXT__ || { instances: [], scrollBound: false, listenersBound: false };
  const state = window.__HF_WAVE_TEXT__;
  const instances = state.instances;
  let ticking = false;

  function initInstance(root) {
    if (root.dataset.hfWaveTextInit === '1') return;
    root.dataset.hfWaveTextInit = '1';

    const textPaths = root.querySelectorAll('.hf-wave-text__path');
    const curve = root.querySelector('.hf-wave-text__curve');
    if (textPaths.length === 0 || !curve) return;

    const pathLength = curve.getTotalLength();

    if (!root.closest('.shopify-section')) {
      textPaths.forEach((p) => p.setAttribute('startOffset', 0));
      return;
    }

    textPaths.forEach((p) => p.setAttribute('startOffset', pathLength));

    const inst = { root, textPaths, pathLength, lastOffset: pathLength };
    instances.push(inst);
    updateInstance(inst);
  }

  function updateInstance(inst) {
    const rect = inst.root.getBoundingClientRect();
    const threshold = 0.2;
    const scrollPercent = (rect.y - window.innerHeight * threshold) / window.innerHeight;
    const newOffset = scrollPercent * 1.1 * inst.pathLength;
    if (Math.abs(newOffset - inst.lastOffset) > 1) {
      inst.textPaths.forEach((p) => p.setAttribute('startOffset', newOffset));
      inst.lastOffset = newOffset;
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      for (const inst of instances) updateInstance(inst);
      ticking = false;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.hf-wave-text').forEach(initInstance);
    if (!state.scrollBound && instances.length > 0) {
      window.addEventListener('scroll', onScroll, { passive: true });
      state.scrollBound = true;
    }
  }

  function deferInitAll(scope) {
    const run = () => initAll(scope);
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => deferInitAll());
  } else {
    deferInitAll();
  }

  if (!state.listenersBound) {
    document.addEventListener('shopify:section:load', (e) => deferInitAll(e.target));
    document.addEventListener('shopify:block:load', (e) => deferInitAll(e.target));
    state.listenersBound = true;
  }
})();
